import { z } from 'zod';
import { QuoteStatus } from '../types/index.js';
export const createQuoteSchema = z.object({
    quoteRequestId: z.string().uuid(),
    vendorId: z.string().uuid(),
    totalAmount: z.number().positive(),
    notes: z.string().max(2000).optional(),
});
export const updateQuoteSchema = z.object({
    totalAmount: z.number().positive().optional(),
    status: z.nativeEnum(QuoteStatus).optional(),
    notes: z.string().max(2000).optional(),
});
export const quoteLineItemSchema = z.object({
    description: z.string().min(1).max(500),
    quantity: z.number().positive(),
    unitPrice: z.number().min(0),
    totalPrice: z.number().min(0),
    sortOrder: z.number().int().min(0),
});
//# sourceMappingURL=quote.js.map